import { Grid } from '@mui/material';
import { ThemePalette } from 'mui.theme';
import Details from './Details';
import Chart from './Chart';
import type { FleetDetailsItem } from 'types/utilization.types';
import { useMemo, useState } from 'react';
import { calculateUtilCurrentDailyAverage } from 'views/Utilization/utils';
import useAppTheme from 'hooks/useAppTheme';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

interface Props {
  chartData: any[];
  detailsData: FleetDetailsItem;
  assetType: 'all' | 'loader' | 'hauler';
  setDetailsVal: any;
  setUserSelections: any;
  selectedChartSource: any;
  setSelectedChartSource: any;
}

const ProductiveHours = ({
  chartData,
  detailsData,
  assetType,
  setDetailsVal,
  setUserSelections,
  selectedChartSource,
  setSelectedChartSource,
}: Props) => {
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;
  const [rollingDailyAverage, setRollingDailyAverage] = useState<number>(0);

  const currentDailyAverage = useMemo(() => {
    return calculateUtilCurrentDailyAverage(chartData ?? []);
  }, [chartData]);

  return (
    <Grid
      container
      spacing={2}
      justifyContent="space-between"
      sx={{
        color: palette.textPrimary,
      }}
    >
      <Details
        data={detailsData}
        currentDailyAvg={currentDailyAverage}
        rollingDailyAverage={rollingDailyAverage}
        assetType={assetType}
        setDetailsVal={setDetailsVal}
      />
      <Chart
        data={chartData}
        setRollingDailyAverage={setRollingDailyAverage}
        setUserSelections={setUserSelections}
        selectedChartSource={selectedChartSource}
        setSelectedChartSource={setSelectedChartSource}
      />
    </Grid>
  );
};

export default ProductiveHours;
